'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { SidebarDesktop as LegacySidebarDesktop } from '#pplx/frontend/apps/ask/layout/sidebar/core/desktop/SidebarDesktopContainer.js';
import { useUnifiedUiSidebarEnabled } from '#pplx/frontend/apps/ask/layout/sidebar/host/useUnifiedUiSidebarEnabled.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
import { useIsMobile } from '#pplx/frontend/platform-components/useMobileStyle.js';
const SidebarSdk = Dynamic(async () => {
    const { SidebarSdk } = await import('#pplx/frontend/apps/ask/layout/sidebar/core/SidebarSdk.js');
    return { default: SidebarSdk };
});
const SidebarMobile = Dynamic(async () => {
    const { SidebarMobile } = await import('#pplx/frontend/apps/ask/layout/sidebar/mobile/SidebarMobileContainer.js');
    return { default: SidebarMobile };
});
export const SearchSidebar = () => {
    const { isMobileStyle } = useIsMobile({ evaluateOnInit: true });
    const isEnabled = useUnifiedUiSidebarEnabled();
    if (isMobileStyle) {
        return _jsx(SidebarMobile, {});
    }
    return isEnabled ? _jsx(SidebarSdk, {}) : _jsx(LegacySidebarDesktop, {});
};
//# sourceMappingURL=SearchSidebar.js.map